import React from "react";
import { FaStar } from "react-icons/fa";

export default function Ready() {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-5 py-12 sm:py-16">
      <h2 className="text-2xl sm:text-3xl md:text-[30px] text-left font-century">
        Ready to Transform Your Life?
      </h2>
      <h3 className="mt-4 sm:mt-6 text-lg sm:text-xl md:text-[20px] text-left font-roboto">
        Join us on January 21-24, 2027, for the{" "}
        <b>On Retreat with Geneen - Live Online</b>.
      </h3>
      <p className="mt-4 sm:mt-6 text-lg sm:text-xl md:text-[20px] text-left font-roboto">
        Don’t wait any longer to heal your relationship with food and old beliefs that limit your life. With expert guidance, a supportive community, and practical
        tools, this transformative experience will empower you to live with
        peace and confidence.
      </p>
      <div className="mt-8 sm:mt-10 text-left font-roboto">
        <div className="flex items-center">
          <span className="inline-flex gap-1 text-yellow-400 text-base sm:text-lg md:text-[21px]">
            {Array.from({ length: 5 }, (_, i) => (
              <FaStar key={i} />
            ))}
          </span>
          <span className="ml-2 font-bold text-lg sm:text-xl md:text-[30px]">
            Join thousands of women
          </span>
        </div>
        <div className="mt-2 text-base sm:text-lg md:text-[20px]">
          Who have broken free from emotional eating, rediscovered their inner
          strength, transformed their lives.
        </div>
      </div>
      <p className="mt-10 sm:mt-14 text-center font-roboto text-lg sm:text-xl md:text-2xl font-semibold">
        Reserve your spot in the January 21-24, 2027 online retreat now
      </p>
      <p className="mt-2 text-center font-roboto text-sm sm:text-base md:text-lg text-gray-600">
        {/* TUITION: <b>$1,495</b> */}
        <span
          className="relative inline-block select-none mx-2
                    before:block before:absolute
                    before:top-1/2 before:left-[-5%]
                    before:w-[110%] before:h-[2px]
                    before:bg-red-600 before:-rotate-[10deg]
                    before:origin-center"
        >
          <span className="text-xl font-roboto font-medium tracking-[0.0075em]">
            $1,595
          </span>
        </span>&nbsp;
        <span className="text-xl font-roboto text-red-600 font-bold">
          $1,495
        </span>
        &nbsp;–&nbsp;
        <span className="text-xl font-roboto text-red-600 font-bold">
          Early Bird Rate
        </span>
      </p>
    </section>
  );
}